export default "__VITE_ASSET__5253d81e__"